import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
var ImageCell = function (_a) {
    var columnName = _a.columnName, content = _a.content, imageAltText = _a.imageAltText, _b = _a.imageHeight, imageHeight = _b === void 0 ? "16px" : _b, imageWidth = _a.imageWidth, id = _a.id;
    return (_jsx("img", { "data-testid": "".concat(columnName, "-image-cell-").concat(id), alt: imageAltText, src: content, height: imageHeight, width: imageWidth, style: {
            verticalAlign: "middle",
        } }));
};
export default React.memo(ImageCell);
